import { TableCell, TableRow, TableBody, TableContainer, Paper, Table, TableHead } from '@mui/material';
import { Delete as DeleteIcon, Add as AddIcon } from '@mui/icons-material'
import { Field, FieldArray, FieldProps, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { FormikEnumerationSelect, FormikNumberFormat } from 'src/common/components/formik';
import { CreateTemplateRequest, TemplateFeeTierRequest } from '../../store';
import { FeeValueMethodEnum } from '../../../store/enums';
import WO2Button from 'src/common/components/button/Button';

export function FeeTierTable(): JSX.Element {
  const { values } = useFormikContext<CreateTemplateRequest>();
  const [lastFeeTier, setLastFeeTier] = useState<TemplateFeeTierRequest | null>(null);
  const isPercent = (feeTier: TemplateFeeTierRequest): boolean => { return feeTier.valueMethod === 'percent' };

  useEffect(() => {
    for (let i = 1; i < values.feeTiers.length; i++) {
      values.feeTiers[i].from = values.feeTiers[i-1].to;
    }

    setLastFeeTier(values.feeTiers.length == 0 ? null : values.feeTiers[values.feeTiers.length - 1]);
  }, [values.feeTiers, setLastFeeTier]);

  return (
    <TableContainer component={Paper} elevation={0} style={{marginBottom: '-16px'}}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>From (Inclusive)</TableCell>
            <TableCell>To (Exclusive)</TableCell>
            <TableCell>Value (incl. GST)</TableCell>
            <TableCell>$/%</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <FieldArray
          name="feeTiers"
          render={arrayHelpers => (
            <TableBody>
              {values.feeTiers.map((feeTier: TemplateFeeTierRequest, index: number) => (
                <TableRow key={index}>
                  <TableCell>
                    <Field name={`feeTiers[${index}].from`}>
                      {(fieldProps: FieldProps) => {
                        return (
                          <FormikNumberFormat
                            formikFieldProps={fieldProps}
                            numberFormatProps={{
                              placeholder: '$0.00',
                              isNumericString: true,
                              allowNegative: false,
                              decimalScale: 2,
                              thousandSeparator: true,
                              prefix: '$',
                              name: fieldProps.field.name,
                              label: '',
                              disabled: true
                            }}
                            isFloatValue={true}
                            fullWidth={true}
                          />
                        );
                      }}
                    </Field>
                  </TableCell>
                  <TableCell>
                    <Field name={`feeTiers[${index}].to`}>
                      {(fieldProps: FieldProps) => {
                        return (
                          <FormikNumberFormat
                            formikFieldProps={fieldProps}
                            numberFormatProps={{
                              placeholder: '$0.00',
                              isNumericString: true,
                              allowNegative: false,
                              decimalScale: 2,
                              thousandSeparator: true,
                              prefix: '$',
                              name: fieldProps.field.name,
                              label: ''
                            }}
                            isFloatValue={true}
                            fullWidth={true}
                          />
                        );
                      }}
                    </Field>
                  </TableCell>
                  <TableCell>
                    <Field name={`feeTiers[${index}].valueWithGst`}>
                      {(fieldProps: FieldProps) => {
                        return (
                          <FormikNumberFormat
                            formikFieldProps={fieldProps}
                            numberFormatProps={{
                              placeholder: isPercent(feeTier) ? '0.00%' : '$0.00',
                              isNumericString: true,
                              allowNegative: false,
                              decimalScale: 2,
                              thousandSeparator: true,
                              prefix: isPercent(feeTier) ? '' : '$',
                              suffix: isPercent(feeTier) ? '%' : '',
                              name: fieldProps.field.name,
                              label: ''
                            }}
                            isFloatValue={true}
                            fullWidth={true}
                          />
                        );
                      }}
                    </Field>
                  </TableCell>
                  <TableCell>
                    <Field
                      component={FormikEnumerationSelect}
                      type={FeeValueMethodEnum}
                      showNone={false}
                      name={`feeTiers[${index}].valueMethod`}
                      label=""
                      fullWidth
                      valueIsId={false}
                    />
                  </TableCell>
                  <TableCell>
                    <WO2Button color="primary"
                      onClick={() => { arrayHelpers.remove(index); }}
                      disabled={index === 0}
                    >
                      <DeleteIcon />
                    </WO2Button>
                  </TableCell>
                </TableRow>
                ))}
                <TableRow>
                  <TableCell colSpan={5}>
                    <WO2Button 
                      variant={'outlined'} 
                      color="primary"
                      startIcon={<AddIcon />}
                      onClick={() => { 
                        arrayHelpers.push({ 
                          from: lastFeeTier?.to || 0, 
                          to: lastFeeTier?.to || 0, 
                          valueWithGst: 0, 
                          valueMethod: lastFeeTier?.valueMethod || FeeValueMethodEnum.Percent.name 
                        } as TemplateFeeTierRequest);
                      }}
                    >
                      Add tier
                    </WO2Button>
                  </TableCell>
              </TableRow>
            </TableBody>                   
          )}
        />
      </Table>
    </TableContainer>
  );
}

